export const MAX_FILE_SIZE = 50 * 1024 * 1024;
